import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface AnnouncementTranslation {
  title: string | null;
  content: string;
}

export interface Announcement {
  id: number;
  title: string | null;
  content: string;
  type: 'info' | 'warning' | 'critical';
  dismissable: boolean;
  date_from: string | null;
  date_to: string | null;
  translations?: { [lang: string]: AnnouncementTranslation };
}

const LOCAL_DISMISS_KEY = 'dismissedAnnouncements';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {

  constructor(private apiService: ApiService) {}

  getPublic(): Observable<{ announcements: Announcement[] }> {
    return this.apiService.get('/announcements/public');
  }

  getMy(): Observable<{ announcements: Announcement[] }> {
    return this.apiService.get('/announcements/my');
  }

  dismissPublic(id: number): Observable<any> {
    this.rememberLocalDismiss(id);
    return this.apiService.post(`/announcements/public/${id}/dismiss`, {});
  }

  dismiss(id: number): Observable<any> {
    return this.apiService.post(`/announcements/${id}/dismiss`, {});
  }

  getLocalDismissedIds(): number[] {
    try {
      const raw = window.localStorage.getItem(LOCAL_DISMISS_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  private rememberLocalDismiss(id: number) {
    try {
      const ids = this.getLocalDismissedIds();
      if (ids.indexOf(id) === -1) {
        ids.push(id);
        window.localStorage.setItem(LOCAL_DISMISS_KEY, JSON.stringify(ids));
      }
    } catch (e) {
      // localStorage niedostępny — trudno, baner wróci po odświeżeniu
    }
  }
}
